import { React, useEffect, useState } from 'react';
import { RightCircleFilled, LeftCircleFilled } from '@ant-design/icons';
import { LoadingTable } from './Utils';
import { Image } from 'antd';

const DisplayStandsForWeb = ({ handleShowModal, occupedStands, hall, standPage, setStandPage, hallState }) => {
  const [stands, setStands] = useState([]);
  const [currentHall, setCurrentHall] = useState('medicine');
  const [loading, setLoading] = useState(false);
  let hallImg = '';

  const hallImgDermo = `${process.env.REACT_APP_PUBLIC_ASSETS}/public/hall_dermo.png`;
  const hallImgMedicamentos = `${process.env.REACT_APP_PUBLIC_ASSETS}/public/hall_medicamentos.png`;
  const hallImgPerfumerias = `${process.env.REACT_APP_PUBLIC_ASSETS}/public/hall_perfumerias.png`;

  useEffect(() => {
    setCurrentHall(hall);
    setStandPage(1);
  }, [hall]);

  switch (hall) {
  case 'perfume':
    hallImg = hallImgPerfumerias;
    break;
  case 'medicine':
    hallImg = hallImgMedicamentos;
    break;
  case 'cosmetic':
    hallImg = hallImgDermo;
    break;
  default:
    hallImg = hallImgDermo;
  }

  useEffect(() => {
    if (hallState === 'noReq') {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [occupedStands, hallState]);

  useEffect(() => {
    const hallOpt = { medicine: 'medicamentos', perfume: 'perfumeria', cosmetic: 'dermocosmetica' };
    const allStands = [];
    let classN = 1;
    for (let i = (standPage * 20 + 1 - 20); i < (standPage * 20 + 1); i++) {
      const findStand = occupedStands.find((stand) => stand.standNumber === i && stand.section === hallOpt[currentHall]);
      if (findStand) {
        const stand = {
          standClass: classN,
          ...findStand
        };
        allStands.push(stand);
      } else {
        const stand = {
          label: `${i}`,
          standNumber: i,
          id: '',
          idBrand: '',
          provider: '',
          type: '',
          section: currentHall,
          standClass: classN
        };
        allStands.push(stand);
      }
      classN++;
    }
    setStands(allStands);
  }, [currentHall, occupedStands, standPage]);

  useEffect(() => {
    let imgContainer = document.getElementById('imgContainer');
    imgContainer.scrollTop = 100;
    imgContainer.scrollLeft = 150;

    let pos = { top: 0, left: 0, x: 0, y: 0 };
    let allPos = [];

    const mouseDownHandler = function (e) {

      pos = {
        left: imgContainer.scrollLeft,
        top: imgContainer.scrollTop,
        x: e.clientX,
        y: e.clientY,
      };

      imgContainer.addEventListener('drag', mouseMoveHandler);
      imgContainer.addEventListener('dragend', mouseUpHandler);

      imgContainer.style.cursor = 'grabbing';
    };

    const mouseMoveHandler = function (e) {

      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;

      imgContainer.scrollTop = pos.top - dy;
      imgContainer.scrollLeft = pos.left - dx;

      const thisPos = {
        y: imgContainer.scrollTop,
        x: imgContainer.scrollLeft,
      };

      allPos.push(thisPos);
    };

    const mouseUpHandler = function () {

      const finalPos = allPos.slice(-2, -1);
      imgContainer.scrollTop = finalPos[0].y;
      imgContainer.scrollLeft = finalPos[0].x;

      imgContainer.style.removeProperty('cursor');

      imgContainer.removeEventListener('drag', mouseMoveHandler);
      imgContainer.removeEventListener('dragend', mouseUpHandler);
    };

    imgContainer.addEventListener('dragstart', mouseDownHandler);

    return () => {
      imgContainer.removeEventListener('dragstart', mouseDownHandler);
    };
  }, []);


  const handleChangeStands = (direction) => {
    setStandPage(standPage + direction);
  };

  return (
    <>
      {loading &&
        <div className="displayStands_loadingContainer" style={{ zIndex: '999', position: 'fixed', width: '100vw', height: 'calc(100vh - 89px)', left: 0, top: '89px' }}>
          <div className="displayStands_loadingStands">
            <LoadingTable />
          </div>
        </div>
      }
      <div className="displayStands_changeStands" style={{ position: 'fixed', width: '100vw', height: 'calc(100vh - 89px)', left: 0, top: '89px' }}>
        {standPage < 4 ? <div className="displayStands_chStandsArrow"><RightCircleFilled onClick={() => handleChangeStands(1)} /></div> : <div className="displayStands_chStandsArrow"></div>}

        {standPage !== 1 && <div className="displayStands_chStandsArrow"><LeftCircleFilled onClick={() => handleChangeStands(-1)} /></div>}
      </div>
      <div className="displayStands_perspectiveContainer">

        <Image preview={false} src={hallImg} alt="" className="displayStands_hall" style={{ height: 'calc(100vh - 89px)' }} />


        {stands.map((stand, i) => {
          if (stand.createdAt) {
            return (
              <div
                key={i}
                className={`stand${stand.standClass}`}
                onClick={() => handleShowModal(stand)}
              >
                {stand.logos.lenght !== 0 ?
                  <Image preview={false} src={stand.logos.lenght !== 0 ? stand.logos[0] : ''} alt="" style={{ width: '70px', height: '30px' }} />
                  : stand.name
                }
              </div>
            );
          } else {
            return (
              <div
                key={i}
                className={`stand${stand.standClass}`}
                style={{
                  cursor: 'grab'
                }}
              >
              </div>
            );
          }
        })}
      </div>

    </>
  );
};

export default DisplayStandsForWeb;
